import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, currency, STATUS_ORDER, STATUS_CONFIG } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import StatusBadge from "../components/StatusBadge";
import { Loader2, Package, ArrowRight } from "lucide-react";

export default function ProfilePage() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/orders/mine")
      .then((r) => setOrders(r.data))
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8" data-testid="profile-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-3">
        <div>
          <div className="text-xs font-mono uppercase text-neutral-500">/perfil</div>
          <h1 className="font-display text-4xl md:text-5xl tracking-tighter mt-1">Hola, {user?.name?.split(" ")[0] || "cliente"}.</h1>
          <p className="text-sm text-neutral-500 mt-2 font-mono">{user?.email}</p>
        </div>
      </div>

      <h2 className="font-display text-2xl tracking-tight mb-4">Mis pedidos</h2>

      {loading ? (
        <div className="py-12 text-center">
          <Loader2 className="w-6 h-6 animate-spin mx-auto text-neutral-400" />
        </div>
      ) : orders.length === 0 ? (
        <div className="brutal-card p-16 text-center" data-testid="profile-no-orders">
          <Package className="w-8 h-8 mx-auto text-neutral-300" />
          <p className="mt-4 text-neutral-500">Aún no tienes pedidos.</p>
          <Link to="/tienda" className="inline-flex items-center gap-1 mt-4 font-medium underline">
            Explorar productos <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => {
            const idx = STATUS_ORDER.indexOf(o.status);
            const progress = idx >= 0 ? ((idx + 1) / STATUS_ORDER.length) * 100 : 0;
            return (
              <Link
                key={o.order_id}
                to={`/pedido/${o.order_id}`}
                className="brutal-card p-5 block hover:-translate-y-0.5 transition-transform"
                data-testid={`profile-order-${o.order_id}`}
              >
                <div className="flex items-start justify-between gap-4 flex-wrap">
                  <div>
                    <div className="text-xs font-mono uppercase text-neutral-500">Pedido</div>
                    <div className="font-display text-xl tracking-tight">{o.order_id}</div>
                    <div className="text-xs text-neutral-500 font-mono mt-1">
                      {new Date(o.created_at).toLocaleDateString("es-MX")} · {o.items.length} artículo(s)
                    </div>
                  </div>
                  <div className="text-right">
                    <StatusBadge status={o.status} />
                    <div className="font-display text-2xl mt-2">{currency(o.total)}</div>
                  </div>
                </div>
                {o.status !== "cancelado" && (
                  <div className="mt-4">
                    <div className="h-1 bg-neutral-100 relative overflow-hidden">
                      <div
                        className="absolute inset-y-0 left-0 transition-all"
                        style={{ width: `${progress}%`, background: STATUS_CONFIG[o.status]?.color || "#0A0A0A" }}
                      />
                    </div>
                    <div className="mt-2 text-xs font-mono text-neutral-500">
                      Entrega estimada: {o.delivery_estimate}
                    </div>
                  </div>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
